export const EMPTY_DROPDOWN_OPTION = '(leer)';
